import { useHeaderConfig } from "@repo/api";
import { type HeaderConfig } from "@repo/api/src/subHeader/types";
import { DEFAULT_LOCALE, getLanguageAndLocaleFromUrl } from "@repo/translation";
import { useMemo } from "react";

import { predefinedTabs } from "./config";
import { getActiveTabPanelId } from "./utils";

export function useSubHeaderConfig() {
  const locale = getLanguageAndLocaleFromUrl();
  const { country, language } = locale ?? DEFAULT_LOCALE;
  const { data: settings, isLoading } = useHeaderConfig(country, language);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const headerConfigs = settings?.header_configs || ({} as HeaderConfig);

  const enabledTabs = useMemo(() => {
    return predefinedTabs
      .filter((tab) => !tab.configKey || headerConfigs?.[tab.configKey])
      .map((tab) => ({
        ...tab,
        url: `/${country}/${language}${tab.url}`,
      }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerConfigs, country, language]);

  const activeTabPanelId = useMemo(() => getActiveTabPanelId(), [enabledTabs]);

  return { enabledTabs, activeTabPanelId, isLoading };
}
